<template>
  <div>
    <div
      v-if="loading"
      class="text-xs-center"
    >
      <v-progress-circular
        :size="50"
        :width="7"
        color="primary"
        indeterminate
      />
    </div>
    <v-data-table
      v-else
      :headers="headers"
      :items="checkouts"
      item-key="_id"
      :pagination.sync="pagination"
      hide-headers
      rows-per-page-text="Resultados por página:"
      class="carts-data-table"
    >
      <template
        #items="props"
        class="table-content"
      >
        <div
          class="text-xs-left px-1 table-content"
          @click="props.expanded = !props.expanded"
        >
          <td class="data">
            <span
              class="table-text"
              style="font-weight: bold"
            >
              Data
            </span>
            <div class="table-text mt-1">
              {{ props.item.createdAt | filtraData }}
            </div>
          </td>
          <td class="data">
            <span
              class="table-text"
              style="font-weight: bold"
            >
              Loja
            </span>
            <div class="table-text mt-1">
              {{ getStoreOrSellerName(props.item, 'storeName') }}
            </div>
          </td>
          <td class="data">
            <span
              class="table-text"
              style="font-weight: bold"
            >
              Vendedor
            </span>
            <div class="table-text mt-1">
              {{ getStoreOrSellerName(props.item, 'sellerName') }}
            </div>
          </td>
          <td style="width: 10%">
            <v-icon
              large
              class="expand-icon"
            >
              {{ !props.expanded ? 'mdi-chevron-down' : 'mdi-chevron-up' }}
            </v-icon>
          </td>
        </div>
      </template>
      <template
        #expand="{ item }"
      >
        <table
          style="width: 100%; border-collapse: collapse"
          class="table-content"
        >
          <thead
            class="mb-1"
            style="border: white"
          >
            <tr>
              <th style="width: 25%">
                Produto
              </th>
              <th style="width: 45%" />
              <th style="width: 30%">
                Valor
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="product in item.products"
              :key="product.idERP"
              class="text-xs-left table-content"
            >
              <td style="padding: 1rem">
                <img
                  style="max-width: 100%"
                  :src="getMainImage(product)"
                  @error="showFallbackImage"
                >
              </td>
              <td style="padding: 0.5rem; color: #848691">
                {{ product.quantity }}x {{ product.descricaoCurta | capitalizeText }}
              </td>
              <td style="color: #848691">
                {{ product.price | currency }}
              </td>
            </tr>
            <tr class="text-xs-center">
              <td />
              <td style="text-align: center">
                <v-btn
                  dark
                  depressed
                  style="text-transform: none; border-radius: 7px"
                  class="my-3"
                  @click="proceedToCheckout(item)"
                >
                  Ir para o carrinho
                </v-btn>
              </td>
            </tr>
          </tbody>
        </table>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { everything } from '@sejazipper/layer-api-client';
import Promise from 'bluebird';
import { mapGetters } from 'vuex';
import format from 'date-fns/format';
import { useZipperApi } from '../composables/useZipperApi';

const { client } = useZipperApi();

export default {
  filters: {
    filtraData(value) {
      if (value) {
        return format(value, 'DD/MM/YY');
      }

      return 0;
    },
    capitalizeText(value) {
      return value.toLowerCase().split(' ').map((w) => w[0].toUpperCase() + w.substring(1)).join(' ');
    },
  },
  props: {
    contato: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    checkouts: [],
    store: null,
    seller: null,
    loading: false,
    pagination: {
      descending: true,
      sortBy: 'data',
    },
    headers: [
      {
        text: 'Data',
        value: 'data',
        sortable: true,
      },
      { text: 'Loja', value: 'loja', sortable: false },
      { text: 'Vendedor', value: 'sellerName', sortable: false },
    ],
  }),
  computed: {
    ...mapGetters([
      'getCustomer',
      'getStore',
    ]),
  },
  async mounted() {
    this.store = await client.chain.query.findStoreByMongoId({
      mongoId: this.getStore.id,
    }).get({ ...everything });

    this.loading = true;
    await this.getAbandonedCarts();
    await Promise.map(this.checkouts, (checkout) => {
      this.getProducts(checkout);
    }, { concurrency: 6 });
    this.loading = false;
  },
  methods: {
    showFallbackImage(event) {
      const e = event;
      e.target.src = 'https://konselior.s3.amazonaws.com/media/semImagem.jpg';
    },
    async getAbandonedCarts() {
      try {
        const checkouts = await client.chain.query
          .getCheckoutsByCpf({
            personCpf: this.contato.cpf.value,
          })
          .get({ ...everything, items: { ...everything, sku: { ...everything } }, person: { ...everything } });

        this.checkouts = checkouts.filter((cart) => !!cart.abandoned);
      } catch (e) {
        console.log(e);
      }
    },
    async getProducts(cart) {
      try {
        const products = [];
        await Promise.map(cart.items, async (product) => {
          const res = await client.chain.query
            .findOMSProductById({ productId: Number(product.idERP) })
            .get({ ...everything, skus: { ...everything } });

          products.push({ ...product, ...res });
        });
        this.$set(cart, 'products', products);
      } catch (e) {
        console.log(e);
      }
    },

    getMainImage(product) {
      return product.skus[0].sku_images.find((sku) => sku.is_main).image;
    },

    getStoreOrSellerName(checkout, field) {
      const store = this.getCustomer.stores.find((s) => s.id === checkout.storeId);
      const seller = store.sellers.find((s) => s.id === checkout.sellerId);

      const checkoutInfo = {
        storeName: store.name,
        sellerName: seller.name,
      };

      return checkoutInfo[field];
    },
    proceedToCheckout(checkout) {
      const { products } = checkout;

      const newProducts = products.map((product) => {
        const skuId = product.sku.sku_id;
        const skuSelected = product.skus.find((sku) => sku.id === skuId);
        const currentStock = skuSelected.sku_stocks.find((stock) => stock.store_id === this.store);
        const productToAdd = {
          ...product,
          ean: skuSelected.ean,
          size: skuSelected.size,
          color: skuSelected.color,
          sku_id: skuSelected.id,
          skuId: `${skuSelected.size || ''}${skuSelected.color || ''}`,
          old_price: product.oldPrice,
          currentStock: currentStock ? currentStock.stock : 0,
          quantity: product.quantity,
        };

        return productToAdd;
      });

      newProducts.forEach((product) => {
        this.checkIfProductHasModification(product);
      });

      this.$store.dispatch('clearCheckout');
      this.$store.dispatch('addProductsToCatalogue', newProducts);
      this.$router.push({ name: 'catalogo', params: { checkout } });
    },

    checkIfProductHasModification(cartItem) {
      if (!cartItem.sku) return;

      const productInStock = cartItem.skus[0].sku_stocks.some(
        (stock) => stock.sku_id === cartItem.sku.sku_id
          && stock.store_id === this.store.id
          && stock.stock >= 1,
      );

      if (!productInStock) this.$set(cartItem, 'modification', 'zeroStock');
    },
  },
};
</script>

<style lang="scss" scoped>

::v-deep .carts-data-table {
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: bold !important;
  font-size: 12px !important;
  line-height: 16px !important;
}

.data {
  font-family: 'Nunito Sans';
  font-style: normal !important;
  font-size: 12px !important;
  line-height: 16px !important;
  font-weight: 600 !important;
}

::v-deep .table-content {
  padding-top: 20px !important;
  padding-bottom: 20px !important;
  vertical-align: middle;
  border-bottom: 0.829458px solid #cccccc;
}

table.v-table thead td:not(:nth-child(1)),
table.v-table tbody td:not(:nth-child(1)),
table.v-table thead th:not(:nth-child(1)),
table.v-table tbody th:not(:nth-child(1)),
table.v-table thead td:first-child,
table.v-table tbody td:first-child,
table.v-table thead th:first-child,
table.v-table tbody th:first-child {
  padding: 0px 8px;
}

.theme--light.v-table thead tr:first-child {
  border-bottom: none;
}

</style>
